import React from 'react';
import useUnmount from '../useUnmount';

const useRafState = (initialState) => {
    const frame = React.useRef(0);
    const [state, setState] = React.useState(initialState);

    const setRafState = React.useCallback((value) => {
        cancelAnimationFrame(frame.current);

        frame.current = requestAnimationFrame(() => setState(value));
    }, []);

    useUnmount(() => cancelAnimationFrame(frame.current));

    return [state, setRafState];
};

export default useRafState;
